import { newsList } from "@/mocks/news";
import type { NewsItem, MediaItem } from "@/types/media";

export const getNewsById = (id: string): NewsItem | undefined =>
  newsList.find((item) => item.id === id);

export const getLatestNews = (limit = 5): NewsItem[] =>
  [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, limit);

export const getRelatedNews = (item: NewsItem, limit = 4): NewsItem[] => {
  const scored = newsList
    .filter((candidate) => candidate.id !== item.id)
    .map((candidate) => {
      let score = 0;
      candidate.tags.forEach((tag) => {
        if (item.tags.includes(tag)) score += 1;
      });
      return { candidate, score };
    })
    .sort((a, b) => b.score - a.score || (a.candidate.date < b.candidate.date ? 1 : -1));
  return scored.slice(0, limit).map((entry) => entry.candidate);
};

export const searchNews = (keyword: string): NewsItem[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return newsList.filter((item) => {
    const haystack = [item.title, item.author, item.source, ...item.tags, item.summary]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
};

export const getNewsForMedia = (item: MediaItem, limit = 3): NewsItem[] => {
  const scored = newsList
    .map((candidate) => {
      let score = 0;
      if (candidate.title.includes(item.title)) score += 5;
      item.genres.forEach((genre) => {
        if (candidate.tags.some((tag) => tag.includes(genre))) score += 1;
      });
      return { candidate, score };
    })
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score || (a.candidate.date < b.candidate.date ? 1 : -1));
  return scored.slice(0, limit).map((entry) => entry.candidate);
};

export const formatNewsDate = (date: string) => {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
};